import { render, staticRenderFns } from "./AddMiniApp.vue?vue&type=template&id=cdcf6ab4&scoped=true&"
import script from "./AddMiniApp.vue?vue&type=script&lang=js&"
export * from "./AddMiniApp.vue?vue&type=script&lang=js&"
import style0 from "./AddMiniApp.vue?vue&type=style&index=0&id=cdcf6ab4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdcf6ab4",
  null
  
)

export default component.exports